import { render, staticRenderFns } from "./OtherUserHistoryList.vue?vue&type=template&id=a848eef2&lang=pug"
import script from "./OtherUserHistoryList.vue?vue&type=script&lang=ts"
export * from "./OtherUserHistoryList.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserHistoryList.vue?vue&type=style&index=0&id=a848eef2&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports